export default __webpack_public_path__ + "static/media/gallery_07.82da03c3.jpg";